import React from 'react'
import { IconProps, IconWrapper } from './IconWrapper'

const renderIcon = (color: string) => (
    <path
        d="M8 14L12 10L16 14"
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
    />
)

export const ArrowChevronUp: React.FC<IconProps> = ({ color, size, ...props }) => (
    <IconWrapper viewBox={'0 0 22 22'} {...{ ...props, size, color }} renderIcon={renderIcon} />
)
